import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormField } from '@/components/UI/FormFields/Latest';
import { handleOpenPickerOnArrowDown } from '@/utils/NativePicker.utils';
import { getRegisterConfig } from '.././FormField.utils';

interface DateTimePickerProps {
  label: string;
  name: string;
  disabled?: boolean;
  hint?: string;
  required?: boolean;
  includeTime?: boolean;
  value?: string;
  testId?: string;
  /**
   * Opt in to opening the browser date picker on ArrowDown. Off by default because it replaces the
   * native ArrowDown behaviour of stepping the focused date segment.
   */
  openPickerOnArrowDown?: boolean;
}

const DateTimePicker: FC<DateTimePickerProps> = ({
  label,
  name,
  disabled = false,
  hint = '',
  required = false,
  includeTime = false,
  value = '',
  testId = 'date-time-picker',
  openPickerOnArrowDown = false,
}) => {
  const { register } = useFormContext();
  return (
    <FormField name={name} label={label} hint={hint} required={required} testPrefix={testId}>
      <div className="w5">
        <input
          type={includeTime ? 'datetime-local' : 'date'}
          step="any"
          defaultValue={value}
          {...register(name, getRegisterConfig({ required }))}
          onKeyDown={(event) => handleOpenPickerOnArrowDown(event, openPickerOnArrowDown)}
          disabled={disabled}
          style={{ marginBottom: 0 }}
          data-testid={testId}
        />
      </div>
    </FormField>
  );
};

export default DateTimePicker;
